export function formatPrice(value) {
  if (value === null || value === undefined || value === "") return "";

  const num = Number(value);
  if (isNaN(num)) return value;

  return num.toLocaleString("he-IL");
}
